import { assign } from 'lodash';

import * as Tool from '../ui/tool';

let { Cx } = window;

assign( Cx, Tool );



/** WEBPACK FOOTER **
 ** ./src/web/tools.js
 **/